<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let open = false;
  export let title = 'Confirm';
  export let message = '';
  export let confirmLabel = 'Confirm';
  export let busy = false;
  export let error: string | null = null;

  const dispatch = createEventDispatcher<{ confirm: void; close: void }>();

  function close() {
    dispatch('close');
  }

  function confirm() {
    dispatch('confirm');
  }
</script>

{#if open}
  <dialog class="confirm-dialog" open>
    <div class="modal-card">
      <header>
        <h3>{title}</h3>
      </header>
      <p>{message}</p>
      {#if error}
        <p class="error">{error}</p>
      {/if}
      <footer>
        <button type="button" class="ghost" on:click={close} disabled={busy}>Cancel</button>
        <button type="button" on:click={confirm} disabled={busy}>{busy ? 'Working…' : confirmLabel}</button>
      </footer>
    </div>
  </dialog>
{/if}

<style>
  .confirm-dialog {
    position: fixed;
    inset: 0;
    margin: auto;
    width: min(420px, 90vw);
    border: none;
    background: rgba(7, 8, 12, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .modal-card {
    width: 100%;
    background: linear-gradient(180deg, rgba(16, 18, 26, 0.95), rgba(16, 18, 26, 0.88));
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: var(--radius-xl);
    padding: var(--space-5);
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  }

  header h3 {
    margin: 0;
  }

  p {
    margin: 0;
  }

  .error {
    color: #ff9a9a;
  }

  footer {
    display: flex;
    justify-content: flex-end;
    gap: var(--space-3);
  }

  button {
    border: none;
    border-radius: var(--radius-lg);
    padding: 0.55rem 1rem;
    cursor: pointer;
    font-weight: 600;
  }

  button.ghost {
    background: rgba(255, 255, 255, 0.12);
    color: inherit;
  }

  button:not(.ghost) {
    background: linear-gradient(135deg, rgba(240, 169, 74, 0.6), rgba(178, 127, 244, 0.4));
    color: #050608;
  }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
